/**
 * Table cell that renders a notes affordance for opening a row-scoped side panel.
 */
import { TableCellNotesIcon } from "../../../../data-model/tableCells";
import NotesIcon from "../../../../svg/notes-icon";

export interface NotesIconCellProps {
  /** Cell value; `hasNotes` shows a top-corner indicator bubble. */
  value?: TableCellNotesIcon | null;
}

/**
 * Renders a centered notes icon control for table rows (e.g. CMM orders).
 * When `value.hasNotes` is true, a small bubble appears at the top-right of the icon.
 *
 * @param props - Optional cell value with `hasNotes` flag.
 * @returns Notes trigger markup (no row click side effects beyond the parent `td` handler).
 */
const NotesIconCell = (props: NotesIconCellProps) => {
  const hasNotes = Boolean(props.value?.hasNotes);

  return (
    <div className="flex justify-center">
      <button
        type="button"
        className="relative flex cursor-pointer items-center justify-center rounded border-none bg-transparent p-1 hover:bg-primaryGray-16"
        aria-label={hasNotes ? "Open order notes (has notes)" : "Open order notes"}
      >
        <NotesIcon />
        {hasNotes ? (
          <span
            className="absolute -right-1 -top-0.5 h-2 w-2 rounded-full bg-[#0056D6]"
            aria-hidden
          />
        ) : null}
      </button>
    </div>
  );
};

export default NotesIconCell;
